var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsNumber, IsString, IsUUID } from 'class-validator';
import { OfficeAchievementLevelStatus } from '../enums/office-achievement-level-status.enum.js';
import { OfficeAchievementLevelChallengeFullSizeDto } from './office-achievement-level-challenge.full-size.dto.js';
import { OfficeAchievementFullSizeDto } from './office-achievement.full-size.dto.js';
export class OfficeAchievementLevelFullSizeDto {
    id;
    createdAt;
    updatedAt;
    levelName;
    levelNumber;
    levelEmoji;
    officeAchievement;
    officeAchievementId;
    officeAchievementLevelChallenges;
    status;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementLevelFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementLevelFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelFullSizeDto.prototype, "levelName", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], OfficeAchievementLevelFullSizeDto.prototype, "levelNumber", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelFullSizeDto.prototype, "levelEmoji", void 0);
__decorate([
    Expose(),
    __metadata("design:type", OfficeAchievementFullSizeDto)
], OfficeAchievementLevelFullSizeDto.prototype, "officeAchievement", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], OfficeAchievementLevelFullSizeDto.prototype, "officeAchievementId", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => OfficeAchievementLevelChallengeFullSizeDto),
    __metadata("design:type", Array)
], OfficeAchievementLevelFullSizeDto.prototype, "officeAchievementLevelChallenges", void 0);
__decorate([
    Expose(),
    IsEnum(() => OfficeAchievementLevelStatus),
    __metadata("design:type", String)
], OfficeAchievementLevelFullSizeDto.prototype, "status", void 0);
//# sourceMappingURL=office-achievement-level.full-size.dto.js.map